import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { Suspense, useState } from 'react';
import { UnsavedChangesDrawer } from '@/domain/termine/components/UnsavedChangesDrawer';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

import { UpdateTermineWrapperProps } from '@/domain/termine/features/UpdateTermin/shared/types';

export function UpdateTermineMobileWrapper({
  onClose,
  children,
  form,
}: UpdateTermineWrapperProps) {
  const { t } = useTranslation();
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] =
    useState(false);

  return (
    <>
      <Drawer
        repositionInputs={false}
        open
        onOpenChange={() => {
          const hasUnsavedChanges = Object.values(form.state.fieldMeta).some(
            (field) => field?.isDefaultValue,
          );
          if (hasUnsavedChanges) setShowUnsavedChangesDialog(true);
          else onClose();
        }}
        dismissible>
        <DrawerContent
          showHandle={false}
          className={cn(
            'h-svh w-screen',
            'rounded-none border-0',
            'data-[vaul-drawer-direction=bottom]:mt-0',
            'data-[vaul-drawer-direction=bottom]:max-h-none',
            'data-[vaul-drawer-direction=bottom]:rounded-none',
            'data-[vaul-drawer-direction=bottom]:border-0',
          )}>
          <DrawerTitle className="sr-only">
            {t('domain.termine.form.terminBearbeiten')}
          </DrawerTitle>
          <DrawerDescription className="sr-only">
            {t('domain.termine.form.terminBearbeiten')}
          </DrawerDescription>
          <Suspense
            fallback={
              <div className="flex flex-col gap-4 items-center justify-center text-sm">
                <FontAwesomeIcon
                  icon={faSpinnerThird}
                  className="text-primary-blue-200"
                  spin
                  size="4x"
                />
                {t('actions.loading')}
              </div>
            }>
            {children}
          </Suspense>
        </DrawerContent>
      </Drawer>

      <UnsavedChangesDrawer
        open={showUnsavedChangesDialog}
        onCancel={() => setShowUnsavedChangesDialog(false)}
        onConfirm={() => {
          form.reset();
          setShowUnsavedChangesDialog(false);
          onClose();
        }}
      />
    </>
  );
}
